export default __webpack_public_path__ + "static/media/mob2.0bc83ffd.jpg";